import { CommonModule } from '@angular/common';
import { Component, OnInit, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { LocalUserRoles } from '@buspro/shared/common';
import { LocalUserDto } from '@buspro/web/apis';
import { NgxAuthService } from '@corelabs/ng-auth';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'buspro-admin-technicians-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './technicians-dashboard.component.html',
})
export class TechniciansDashboardComponent implements OnInit {
  private router = inject(Router);
  private ngxAuthService = inject(NgxAuthService);
  private logger = inject(NGXLogger);

  // Convert Observable to Signal for easier access
  authUser: Signal<LocalUserDto | null> = toSignal(this.ngxAuthService.state, { initialValue: null });

  ngOnInit(): void {
    // Check if user is NOT a technician - redirect them to main dashboard
    const currentUser = this.authUser();
    if (currentUser) {
      const role = currentUser.role;
      if (role !== LocalUserRoles.LOCAL_TECHNICIAN) {
        this.logger.info('Non-technician detected, redirecting to main dashboard');
        this.router.navigateByUrl('/dashboard');
        return;
      }
    }
  }
}
